import { frontendURL } from '../../../../helper/URLHelper';

// Le rotte della sezione conversazioni. Le usa anche il router per capire
// se si sta entrando nella sezione da fuori (vedi helper/landingRoute.js).
export const CONVERSATION_ROUTE_NAMES = [
  'home',
  'inbox_dashboard',
  'inbox_conversation',
  'conversation_through_inbox',
  'label_conversations',
  'conversations_through_label',
  'conversation_participating',
  'conversation_through_participating',
  'folder_conversations',
  'conversations_through_folders',
  'conversation_unattended',
  'conversation_through_unattended',
];

const conversations = (accountId) => ({
  parentNav: 'conversations',
  routes: CONVERSATION_ROUTE_NAMES,
  menuItems: [
    {
      icon: 'chat',
      customIcon:
        'https://storage.googleapis.com/template-otello/web_icons/all_conversations.png',
      label: 'ALL_CONVERSATIONS',
      key: 'conversations',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'home',
    },
    // {
    //   icon: 'mail-unread',
    //   label: 'UNATTENDED_CONVERSATIONS',
    //   key: 'conversation_unattended',
    //   toState: frontendURL(`accounts/${accountId}/unattended/conversations`),
    //   toStateName: 'conversation_unattended',
    // },
  ],
});

export default conversations;
